// js-dropdown-active ul
//

setTimeout(function() {

  var megaMenu = jQuery('.mega-sub-menu li');

  // sort menu items
  jQuery('.mega-sub-menu').each(function() {
    var child = jQuery(this).find('li');
    var countLeft = child.length % 3;
    var section = 4 - countLeft;

    if (child.length == 10) {
      section = 4;
    }
    if (child.length == 14 || child.length == 15) {
      section = 5;
    }
    if (child.length == 16 || child.length == 17 || child.length == 18) {
      section = 6;
    }
    if (child.length >= 19) {
      section = 7;
    }

    for (var i = 0; i < child.length; i += section) {
      child.slice(i, i + section).wrapAll('<li class="mega-sub-col col-' + i + '"></li>');
    }
    var secondLastItem;
    var thirdLastItem;

    if (child.length == 4) {
      secondLastItem = jQuery(this).find('.col-0 li:last-child');
      thirdLastItem = jQuery(this).find('.col-3 li:last-child');
      secondLastItem.insertBefore(thirdLastItem);
    }
    if (section == 4 && countLeft == 1) {
      secondLastItem = jQuery(this).find('.col-4 li:last-child');
      thirdLastItem = jQuery(this).find('.col-8 li:last-child');
      secondLastItem.insertBefore(thirdLastItem);
    }

    if (section == 5 && countLeft == 1) {
      secondLastItem = jQuery(this).find('.col-5 li:last-child');
      thirdLastItem = jQuery(this).find('.col-10 li:last-child');
      secondLastItem.insertBefore(thirdLastItem);
    }

    if (section == 6 && countLeft == 1) {
      secondLastItem = jQuery(this).find('.col-6 li:last-child');
      thirdLastItem = jQuery(this).find('.col-12 li:last-child');
      secondLastItem.insertBefore(thirdLastItem);
    }
    if (section == 7 && countLeft == 1) {
      secondLastItem = jQuery(this).find('.col-7 li:last-child');
      thirdLastItem = jQuery(this).find('.col-14 li:last-child');
      secondLastItem.insertBefore(thirdLastItem);
    }

  });

  // Hovering over menu items
  jQuery('#menu-main-menu-top-level li.has-children').mouseenter(function() {
    jQuery('#menu-main-menu-top-level li.active-sub-menu').each(function() {
      jQuery(this).removeClass('active-sub-menu');
    });
    jQuery(this).addClass('active-sub-menu');
    jQuery('.mega-sub-menu.aa').removeClass('mega-sub-menu-show');
    jQuery('.mega-sub-menu.tx').removeClass('mega-sub-menu-show');
    jQuery('.mega-sub-menu.fv').removeClass('mega-sub-menu-show');
    jQuery('.mega-sub-menu.ad').removeClass('mega-sub-menu-show');
    jQuery('.mega-sub-menu.in').removeClass('mega-sub-menu-show');
    if (jQuery(this).hasClass('aa')) {
      jQuery('.mega-sub-menu.aa').addClass('mega-sub-menu-show');
    }
    if (jQuery(this).hasClass('tx')) {
      jQuery('.mega-sub-menu.tx').addClass('mega-sub-menu-show');
    }
    if (jQuery(this).hasClass('fv')) {
      jQuery('.mega-sub-menu.fv').addClass('mega-sub-menu-show');
    }
    if (jQuery(this).hasClass('ad')) {
      jQuery('.mega-sub-menu.ad').addClass('mega-sub-menu-show');
    }
    if (jQuery(this).hasClass('in')) {
      jQuery('.mega-sub-menu.in').addClass('mega-sub-menu-show');
    }
  });

  // Show the background
  jQuery('#menu-main-menu-top-level .menu-item.has-children').mouseenter(function() {
    var TopNav = jQuery('#top-bar-menu');
    var MegaNav = jQuery('#menu-mega');
    jQuery('.menu-wrapper .menu-background').css({
      top: TopNav.height() + MegaNav.height()
    });
  });

  // Close the menu
  function closeMegaMenu() {
    jQuery('.menu-wrapper .menu-background').css('top', '-800px');
    jQuery('.mega-sub-menu.mega-sub-menu-show').each(function() {
      jQuery(this).removeClass('mega-sub-menu-show');
    });
    jQuery('#menu-main-menu-top-level li.active-sub-menu').each(function() {
      jQuery(this).removeClass('active-sub-menu');
    });
  }

  jQuery('#top-bar-menu' || '.main-menu-left' || '.main-menu-right').mouseenter(function() {
    closeMegaMenu();
  });

  jQuery('#menu-main-menu-top-level .no-sub').mouseenter(function() {
    closeMegaMenu();
  });

  jQuery('#menu-bottom-close').mouseenter(function() {
    closeMegaMenu();
  });

  jQuery('#close-mega-menu').click(function() {
    closeMegaMenu();
  });

}, 500);